<template>
	<!-- Open the modal using ID.showModal() method -->
	<dialog
		class="modal"
		ref="errorModalRef">
		<div class="modal-box bg-popup-bg text-popup-text">
			<h3 class="text-lg font-bold">{{ titleText }}</h3>
			<p class="py-4">{{ bodyText }}</p>
			<div class="modal-action">
				<FormBtn
					preset="primary"
					:rounded="false"
					@click="closeModal">
					{{ closeBtnText }}
				</FormBtn>
			</div>
		</div>
	</dialog>
</template>

<script setup>
	import { HIDE_ERROR, SHOW_ERROR } from "assets/events/errors"
	import { useI18n } from "vue-i18n"

	const { t } = useI18n()
	const { $eventBus } = useNuxtApp()

	const hideCloseBtn = ref(false)
	const bodyText = ref(t("errorPageBody"))
	const titleText = ref(t("errorPopupDefaultTitle"))
	const closeBtnText = ref(t("ok"))
	const closeCallback = ref(null)
	const errorModalRef = ref(null)

	const openModal = () => {
		try {
			errorModalRef.value.showModal()
		} catch (e) {
			//Immediately force a page refresh to try to rectify any issues
			reloadNuxtApp()
		}
	}

	const hideModal = () => {
		try {
			errorModalRef.value.close()
		} catch (e) {
			//Immediately force a page refresh to try to rectify any issues
			reloadNuxtApp()
		}
	}

	const closeModal = () => {
		closeCallback.value && typeof closeCallback.value === "function" && closeCallback.value()
		hideModal()
	}

	onMounted(() => {
		$eventBus.$on(SHOW_ERROR, (options) => {
			hideCloseBtn.value = options && options.hideCloseBtn ? options.hideCloseBtn : false
			titleText.value = options && options.titleText ? options.titleText : t("errorPopupDefaultTitle")
			bodyText.value = options && options.bodyText ? options.bodyText : t("errorPopupDefaultBody")
			closeBtnText.value = options && options.closeBtnText ? options.closeBtnText : t("ok")
			closeCallback.value = options && options.closeCallback ? options.closeCallback : null
			openModal()
		})

		$eventBus.$on(HIDE_ERROR, hideModal)
	})

	onUnmounted(() => {
		$eventBus.$off(SHOW_ERROR)
		$eventBus.$off(HIDE_ERROR)
	})
</script>
